import styled from 'styled-components'
import { Row } from 'antd'

export const StyledContactUsWrapper = styled(Row)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px;
  height: auto;
  width: 707px;
  background-color: var(--white);
  box-shadow: 0 13px 32px 9px rgba(0, 0, 0, 0.07);
  border-radius: 15px;
  box-sizing: border-box;
  position: relative;
  margin: 50px auto;

  .ant-form {
    width: 100%;
    .ant-image-img {
      text-align: center;
    }

    .ant-input-textarea {
      border: 1px solid var(--grey);
      border-radius: 10px;
      label &.label {
        margin: 12px !important;
      }
    }

    .ant-btn-primary {
      display: flex;
      justify-content: center;
    }
  }

  @media only screen and (max-width: 768px) {
    width: 100% !important;
    box-shadow: none !important;
    padding: 25px;
  }
`
export const StyledH1 = styled.h1`
  color: var(--cognac);
  text-align: center;
`
